<template>
  <div>
    <transition name="slide-in-up">
      <div class="bottom-bar" v-show="$store.state.isBottomBarVisible">
        <div class="bottom-bar__main touch" @click.self="navigateToDefaultPage">
          <router-link v-if="styles['general']['show-sensoreal-branding']" to="/" tag="span" class="touch" style="position: absolute; left: 5rem;">
            <img class="bottom-bar__sensoreal-logo" src="/assets/sensoreal.png">
          </router-link>
          <a 
            v-if="$store.state.selector"
            href="http://localhost:9000"
            class="selector-btn touch"
            style="position: absolute; left: 20rem;"
          >
            <span v-html="$store.state.selector"></span>
          </a>
          <router-link v-if="styles['general']['show-home-button']" :to="defaultPage" tag="span" class="btn-circle touch" style="position: absolute; left: 20rem;">
            <fa :icon="['fas', 'home']" />
          </router-link>
          <!-- <transition-group
            class="bottom-bar__nav-items"
            :class="{ 'dir-rtl' : language.rtl }"
            @before-enter="beforeEnter"
            @enter="enter"
            @afterEnter="afterEnter"
            @leave="leave"
          >              -->
            <div
              v-for="(item, index) in activeNavItems"
              class="bottom-bar__nav-item-wrapper"
              :class="[
                { 'bottom-bar__nav-item-wrapper--active': isNavItemActive(item) },
                { 'bottom-bar__nav-item-wrapper--last-item' : item.isLiveSection }
              ]"
              :data-index="index"
              :key="item._id"
            >
              <router-link 
                class="btn bottom-bar__nav-item touch"
                :class="[
                  { 'router-link-active': isNavItemActive(item) },
                  { 'btn--live': item.isLiveSection }
                ]"
                tag="button"
                :to="getItemLink(item)"
                :style="`
                  font-size: ${styles['bottom-bar']['font-size']};
                  font-weight: ${styles['bottom-bar']['font-weight']};
                `"
                @click.native="triggerVideo(item.videoWallTrigger); playClickSound()"
              >
                <span class="bottom-bar__nav-label" v-html="item.label[language.code]"></span>
              </router-link>
            </div>
            <!-- <div v-if="activeNavItems.length" class="bottom-bar__nav-item-wrapper" data-index="4" key="foo">
              <button
                class="btn bottom-bar__nav-item touch"
                :style="`
                  font-size: ${styles['bottom-bar']['font-size']};
                  font-weight: ${styles['bottom-bar']['font-weight']};
                `"
                @click="$store.dispatch('triggerIframeLocal', 'https://vista.metaluxe.com.au')"
              >Virtual Tour</button>
            </div> -->
          <!-- </transition-group> -->
        </div>

        <div class="bottom-bar__sub">
          <router-link
            v-if="styles['general']['show-favourites'] === true" 
            class="btn btn--favourite touch"
            :class="{ 'btn--inactive': !favourites.length }"
            tag="button"
            :to="viewFavouriteLink"
          >
            <div class="btn__icon">
              <fa :icon="['far', 'heart']" />
            </div>
            <div>View Favourites</div>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { bus } from '../main'

export default {
  props: ['nav-items'],

  data () {
    return {
      activeNavItems: [],
    }
  },

  computed: {
    ...mapGetters({
      activePage: 'activePage',
      favourites: 'favourites/favourites',
      viewFavouriteLink: 'favourites/viewFavouritesLink',
      language: 'language',
      styles: 'styleTemplate'
    }),

    env () {
      return process.env
    },

    defaultPage () {
      const categoryId = this.$store.state.route.params.categoryId
      const navigation = _.find(this.$store.state.navigation, navigation => {
        return navigation._id === this.$store.state.route.params.categoryId
      })
      
      if (navigation) {
        return navigation.defaultChildUrl ? navigation.defaultChildUrl : `/category/${categoryId}/page/${navigation.children[0].pageId}`
      }

      return '/'
    }
  },

  watch: {
    navItems: {
      handler (oldNavItems, newNavItems) {
        if (!_.isEqual(oldNavItems, newNavItems)) {
          if (oldNavItems.length) {
            this.activeNavItems = []
          }

          this.$store.commit('addAnimationToQueue', 'BottomBar')
        }
      },
      immediate: true
    }
  },

  mounted () {
    bus.$on('animateBottomBar', () => {
      if (!_.isEqual(this.activeNavItems, this.navItems)) {
        this.activeNavItems = this.navItems
      } else {
        bus.$emit('finishedAnimation')
      }
    })
  },

  methods: {
    ...mapActions([
      'triggerVideo',
      'playClickSound'
    ]),

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        done()
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        bus.$emit('finishedAnimation')
      } 
    },    

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`
    },

    getItemLink (item) {
      if (item.customRoute) {
        return item.customRoute
      }

      return `/category/${this.$store.state.route.params.categoryId}/page/${item.pageId}`
    },

    isNavItemActive (item) {
      return this.activePage && (item.pageId === this.activePage._id || _.find(item.children, child => {
        return child.pageId === this.activePage._id
      }))
    },

    navigateToDefaultPage () {
      this.$router.push(this.defaultPage).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_buttons.scss";

.selector-btn {
  border: 0.01rem solid #fff;
  border-radius: .35rem;
  font-size: 1rem;
  opacity: .6;
  padding: .5rem .6rem .4rem;
  text-align: center;
  text-transform: uppercase;
  top: 2rem;
}

.bottom-bar {
  bottom: 0;
  left: 0;
  display: flex;
  position: absolute;
  width: 100%;
  z-index: 110;

  &__main {
    align-items: center;
    background-color: $bottombar-bg-color;
    bottom: 0;
    display: flex;
    flex-grow: 1;
    height: 10rem;
    justify-content: center;
    padding: 1.9rem 0;
  }

  &__sub {
    align-items: flex-start;
    background-color: $bottombar-bg-color;
    display: flex;
    justify-content: flex-end;
    padding: 1.9rem 5rem;
    width: 32.5rem;

    .btn {
      margin: 0 auto 0 0;

      &--inactive {
        opacity: .15;
      }
    }
  }

  &__nav-items {
    align-self: flex-start;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    margin-right: 8.5rem;
  }

  &__nav-item-wrapper {
    display: flex;

    &--last-item {
      margin-left: 4rem;
      padding: 0 4rem;
      position: absolute;
      right: 32.5rem;

      .bottom-bar__nav-item {
        margin: 0;
      }

      .btn--live.router-link-active {
        // color: $white;
      }

      &::after {
        background: #4d555b;
        content: '';
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: .1rem;
      }

      &::before {
        background: #4d555b;
        content: '';
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        width: .1rem;
      }
    }
  }

  &__nav-item {
    margin: 0 1rem;

    &.router-link-active, &--active {
      color: $black;
    }
  }

  &__sensoreal-logo {
    width: 11rem;
  }

  &__version {
    color: rgba(255, 255, 255, 0.25);
    display: block;
    text-align: right;
  }
}
</style>
